let currentActiveStageId = null;

document.addEventListener('DOMContentLoaded', () => {
    const dataEl = document.getElementById('js-mystery-letters-data');
    if (!dataEl) return;

    let letters;
    try {
        letters = JSON.parse(dataEl.textContent);
    } catch {
        return;
    }
    if (!Array.isArray(letters) || !letters.length) return;

    // Append to the section, not to .js-days-cards — stage-transitions.js
    // snapshots and restores .js-days-cards innerHTML on every stamp click,
    // which would wipe anything appended there after DOMContentLoaded.
    const section = document.querySelector('.s-stage-days');
    if (!section) return;

    const now = Date.now();
    const letterEls = [];
    const unlocked = [];

    letters.forEach((letter, i) => {
        const start = +new Date(letter.dateStart);

        const el = buildLetterEl(letter);
        section.appendChild(el);
        letterEls.push(el);
        unlocked.push(false);

        const unlock = () => {
            unlocked[i] = true;
            refreshVisibility(letters, letterEls, unlocked);
        };

        if (now >= start) {
            unlock();
        } else {
            setTimeout(unlock, start - now);
        }

    });

    const collecting = new Set();
    document.addEventListener('click', e => {
        for (let i = 0; i < letterEls.length; i++) {
            const el = letterEls[i];
            if (el.hasAttribute('hidden') || collecting.has(i)) continue;
            const rect = el.getBoundingClientRect();
            if (e.clientX >= rect.left && e.clientX <= rect.right &&
                e.clientY >= rect.top  && e.clientY <= rect.bottom) {
                e.stopPropagation();
                collecting.add(i);
                collectLetter(letters[i], el, e.clientX, e.clientY)
                    .finally(() => collecting.delete(i));
                break;
            }
        }
    }, true);

    document.addEventListener('click', e => {
        const trigger = e.target.closest('.js-stamp-trigger');
        if (!trigger) return;
        currentActiveStageId = trigger.dataset.stageId ? Number(trigger.dataset.stageId) : null;
    });

    const daysScreenEl = document.querySelector('.js-screen[data-screen="days"]');
    if (daysScreenEl) {
        const observer = new MutationObserver(() => refreshVisibility(letters, letterEls, unlocked));
        observer.observe(daysScreenEl, { attributes: true, attributeFilter: ['class'] });
    }

    initModal();
});

function refreshVisibility(letters, letterEls, unlocked) {
    const daysEl = document.querySelector('.js-screen[data-screen="days"]');
    const daysReady = !daysEl ||
        (daysEl.classList.contains('is-active') && !daysEl.classList.contains('is-entering'));

    letterEls.forEach((el, i) => {
        const letterStageId = letters[i].stageId ?? null;
        const stageMatch = letterStageId === null || letterStageId === currentActiveStageId;
        if (daysReady && unlocked[i] && stageMatch) {
            el.removeAttribute('hidden');
        } else {
            el.setAttribute('hidden', '');
        }
    });
}

function assets() {
    return document.getElementById('js-mystery-letter-assets');
}

function buildLetterEl(letter) {
    const el = document.createElement('div');
    el.className = `mystery-letter mystery-letter--${letter.position}`;
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');

    const img = document.createElement('img');
    img.src = assets()?.dataset.letterSvg || '';
    img.alt = '';
    el.appendChild(img);

    return el;
}

async function collectLetter(letter, el, x, y) {
    try {
        const res = await fetch('/api/mystery-letter', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                uuid: letter.uuid,
                x: x / window.innerWidth * 100,
                y: y / window.innerHeight * 100,
                stageId: currentActiveStageId,
            }),
        });

        if (res.ok) {
            const data = await res.json();
            if (!data.dev) el.remove();
            showModal(data);
        } else {
            el.remove();
        }
    } catch {
        // network error — collecting Set cleaned up by .finally() in caller
    }
}

function initModal() {
    const modal = document.getElementById('js-mystery-letter-modal');
    if (!modal) return;

    modal.querySelector('.js-ml-close')?.addEventListener('click', closeModal);
    modal.addEventListener('click', e => {
        if (e.target === modal) closeModal();
    });
}

function showModal(data) {
    const modal = document.getElementById('js-mystery-letter-modal');
    if (!modal) return;

    const pointsEl = modal.querySelector('.js-ml-reward-points');
    const heartEl  = modal.querySelector('.js-ml-reward-heart');

    pointsEl.setAttribute('hidden', '');
    heartEl.setAttribute('hidden', '');

    if (data.rewardType === 'points') {
        modal.querySelectorAll('.js-ml-points-value').forEach(el => {
            el.textContent = `+${data.rewardValue}`;
        });
        pointsEl.removeAttribute('hidden');
    } else if (data.rewardType === 'sephocrush_life') {
        const label = data.rewardValue === 1 ? 'życie' : 'życia';
        const heartImg = modal.querySelector('.js-ml-heart-img');
        if (heartImg) heartImg.alt = `+${data.rewardValue} ${label}`;
        modal.querySelector('.js-ml-heart-label').textContent = `+${data.rewardValue}`;
        heartEl.removeAttribute('hidden');
    }

    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-mystery-letter-open');
}

function closeModal() {
    const modal = document.getElementById('js-mystery-letter-modal');
    if (!modal) return;
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-mystery-letter-open');
}
